import React from "react";
import StarRow from "./StarRow";
import { RT, MIN_AVERAGE_TO_DISPLAY } from "./reviewTokens";
import { formatScore } from "./reviewMath";
import { productCardRating } from "./normalize";

const ProductCardRating = ({ product, isMobile = false, style = {} }) => {
  const rating = productCardRating(product);
  if (!rating || rating.score < MIN_AVERAGE_TO_DISPLAY) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "5px",
        marginTop: "4px",
        ...style,
      }}
    >
      <StarRow value={rating.score} size={isMobile ? 10 : 11} spacing={0.5} />
      <span
        style={{
          fontSize: isMobile ? "10.5px" : "11.5px",
          fontWeight: 800,
          color: RT.ink,
        }}
      >
        {formatScore(rating.score)}
      </span>
      <span
        style={{
          fontSize: isMobile ? "10px" : "11px",
          fontWeight: 600,
          color: RT.muted,
        }}
      >
        ({rating.count.toLocaleString()})
      </span>
    </div>
  );
};

export default ProductCardRating;
